import React, { useEffect, useState } from 'react';
import SharedRecipeDetail from './sharedRecipeDetail';
import SharedRecipeInfo from './SharedRecipeInfo';
import { AxiosResponse } from 'axios';
import paymentAPI from '../deprecated/payment/api';
import { Alert } from 'reactstrap';
import history from 'src/lib/history';
import { Meal } from './types';
import Loader from 'src/components/content/loader';
import SharedRecipeExpired from './SharedRecipeExpired';
import { EVENTS, track } from 'src/util/track';
import { getRecipeParamsFromUrl } from './utils/sharedRecipe.util';

const SharedRecipe = () => {
  const [userEmail, setUserEmail] = useState('');
  const [recipeData, setRecipeData] = useState<Meal | null>(null);
  const [loading, toggleLoading] = useState(true);
  const [showExpiredError, setShowExpiredError] = useState(false);

  const { recipeId: recipe_id, sharedToken: shared_token } =
    getRecipeParamsFromUrl(window.location.href);

  useEffect(() => {
    if (!shared_token || !recipe_id) return;
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shared_token, recipe_id]);

  const submitUserEmail = async (guestEmail: string) => {
    toggleLoading(true);
    try {
      await paymentAPI.post('/api/shared-recipe/add-viewer', {
        recipe_id,
        shared_token,
        email: guestEmail,
      });
      track(EVENTS.recipeEmailSubmitted, {
        email: guestEmail,
        recipeId: recipe_id,
      });
      setUserEmail(guestEmail);
    } catch (err) {
      console.error('Failed to submit viewer email', err);
    } finally {
      toggleLoading(false);
    }
  };

  const fetchData = async () => {
    if (!shared_token || !recipe_id) {
      history.push('/');
      return;
    }
    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const recipeResponse: AxiosResponse = await paymentAPI.get(
        `/api/shared-recipe?shared_token=${shared_token}&timezone=${timezone}`
      );
      if (recipeResponse?.data?.success) {
        setRecipeData(recipeResponse.data);
      }
    } catch (error) {
      setShowExpiredError(true);
    } finally {
      toggleLoading(false);
    }
  };

  return (
    <>
      {!shared_token || !recipe_id ? (
        <Alert color="danger">
          Wrong data passed. Please check URL properly.
        </Alert>
      ) : loading ? (
        <Loader />
      ) : showExpiredError ? (
        <SharedRecipeExpired />
      ) : userEmail ? (
        <SharedRecipeDetail recipeData={recipeData} />
      ) : (
        <SharedRecipeInfo
          recipeData={recipeData}
          onSubmitEmail={submitUserEmail}
        />
      )}
    </>
  );
};

export default SharedRecipe;
